import React from "react"
import { Box, Typography } from '@mui/material'
import VolumeUpIcon from '@mui/icons-material/VolumeUp'
import makeStyles from "@mui/styles/makeStyles"

const useStyles = makeStyles((theme) => {
    return {
        '@keyframes fadeSlideIn': {
            '0%': {
                opacity: 0,
                transform: 'translateY(-10px)'
            },
            '100%': {
                opacity: 1,
                transform: 'translateY(0)'
            }
        },
        containerCommandItem: {
            alignItems: 'center',
            animation: '$fadeSlideIn 0.3s ease-out',
            [theme.breakpoints.up('sm')]: {
                display: 'grid',
                gridTemplateColumns: 'repeat(6, 1fr)',
                gap: 1,
                gridTemplateRows: 'auto',
                gridTemplateAreas: `"commandItem1 commandItem2 commandItem3 commandItem4 commandItem5 commandItem6"`,
            },
            [theme.breakpoints.down('sm')]: {
                display: 'grid',
                gridTemplateColumns: 'repeat(4, 1fr)',
                gap: 1,
                gridTemplateRows: 'auto',
                gridTemplateAreas: `"commandItem1 commandItem2 commandItem3 commandItem3" 
                "commandItem4 commandItem5 commandItem6 commandItem6"`,
            }
        },
        commandItem1: {
            gridArea: "commandItem1",
        },
        commandItem2: {
            gridArea: "commandItem2",
        },
        commandItem3: {
            gridArea: "commandItem3",
        },
        commandItem4: {
            gridArea: "commandItem4",
        },
        commandItem5: {
            gridArea: "commandItem5",
        },
        commandItem6: {
            gridArea: "commandItem6",
        }
    }
})

export default function CommandItem({ commandData }) {
    const classes = useStyles()

    const getDescription = (code) => {
        switch (code) {
            case "DESL": return "SISTEMA RESTAURADO";
            case "LIGA": return "ALARME DE ABANDONO";
            case "SILE": return "SILENCIAR ALARME";
            case "PANI": return "ALARME DE BRIGADA";
            default: return code || "";
        }
    }

    const commandDescription = getDescription(commandData.dS_DESCRICAO_ALARME);
    const commandDate = new Date(commandData.dT_ALARME).toLocaleString().replace(',', '');
    const commandLocal = commandData.dS_LOCAL_ALARME === "0" ? "Geral" : (commandData.dS_LOCAL_ALARME || "");
    const commandOrigin = commandData.dS_ORIGEM_ALARME || "";
    const serial = commandData.fK_CENTRAL || "";

    const newColor = (row) => {
        if (row.dS_DESCRICAO_ALARME === "DESL") {
            return "#00B33C"
        }
        if (row.dS_DESCRICAO_ALARME === "PANI") {
            return "#F58634"
        }
        if (row.dS_DESCRICAO_ALARME === "SILE") {
            return "#FFEA00"
        }
        if (row.dS_DESCRICAO_ALARME === "LIGA") {
            return "#CA373C"
        }
    }

    return (
        <div>
            <Box className={classes.containerCommandItem}>
                <Box className={classes.commandItem1}><VolumeUpIcon sx={{ color: newColor(commandData) }} /></Box>
                <Box className={classes.commandItem2}> <Typography variant="delta">{serial}</Typography></Box>
                <Box className={classes.commandItem3}><Typography variant="delta">{commandDescription}</Typography></Box>
                <Box className={classes.commandItem4}><Typography variant="delta">{commandLocal}</Typography></Box>
                <Box className={classes.commandItem5}><Typography variant="delta">{commandOrigin}</Typography></Box>
                <Box className={classes.commandItem6}><Typography variant="delta">{commandDate}</Typography></Box>
            </Box>
        </div>
    )
}